import React, { useState } from "react";
import styles from "./MarketPlaceRequiredField.module.css";
import { Form, ButtonGroup, Button } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import { MdOutlineEditNote } from "react-icons/md";

const MarketPlaceRequiredField = ({
  jsonData = [],
  setJsonData,
  requiredFieldCloseHandler,
  adminVendorId,
  productVendorId,
}) => {
  //ADD-NEW-FIELD-STATES:
  const [showAddFieldModal, setShowAddFieldModal] = useState(false);
  const [addFieldLoader, setAddFieldLoader] = useState(false);
  const [type, setType] = useState("");
  const [placeholder, setPlaceholder] = useState("");
  const [title, setTitle] = useState("");
  const [required, setRequired] = useState(true);
  const [name, setName] = useState("");
  const [info, setInfo] = useState("");
  const [link, setLink] = useState("");
  //EDIT FIELD STATES:
  const [showEditFieldModal, setShowEditFieldModal] = useState(false);
  const [editDataIndex, setEditDataIndex] = useState(null);
  const [editFieldLoader, setEditFieldLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const editFieldOpenHandler = (data, index, e) => {
    e.preventDefault();
    setType(data.type);
    setPlaceholder(data.placeholder);
    setTitle(data.title);
    setRequired(data.required);
    setName(data.name);
    setInfo(data.info);
    setLink(data.link);
    setEditDataIndex(index);
    setShowEditFieldModal(true);
  };
  const editFieldCloseHandler = () => {
    setShowEditFieldModal(false);
  };

  const addFieldOpenHandler = (e) => {
    e.preventDefault();
    setType("");
    setPlaceholder("");
    setTitle("");
    setRequired(true);
    setName("");
    setInfo("");
    setLink("");
    setShowAddFieldModal(true);
  };
  const addFieldCloseHandler = () => {
    setShowAddFieldModal(false);
  };

  const addFieldSubmitHandler = (e) => {
    e.preventDefault();
    const formData = {
      type,
      placeholder,
      title,
      required,
      name,
      info,
      link,
    };
    if (formData.name === "" || formData.title === "") {
      setErrorMsg("All Fields are required");
      return;
    }
    setAddFieldLoader(true);
    setJsonData([...jsonData, formData]);
    setAddFieldLoader(false);
    setShowAddFieldModal(false);
  };
  const editFieldSubmitHandler = (e) => {
    e.preventDefault();
    setEditFieldLoader(true);
    const formData = {
      type,
      placeholder,
      title,
      required,
      name,
      info,
      link,
    };

    const updatedData = jsonData.map((item, index) =>
      index === editDataIndex ? formData : item,
    );
    setJsonData(updatedData);
    setEditDataIndex(null);
    setEditFieldLoader(false);
    setShowEditFieldModal(false);
  };

  return (
    <>
      <div
        className={styles.backdropContainer}
        onClick={requiredFieldCloseHandler}
      ></div>
      <div className={styles.container}>
        {!addFieldLoader && (
          <section className={styles.section}>
            <div className={styles.sectionHeading}>
              <h2 className={styles.header}>Required Fields</h2>
              {adminVendorId === productVendorId && (
                <button
                  onClick={(e) => {
                    addFieldOpenHandler(e);
                  }}
                  className={styles.addField}
                >
                  Add Fields
                </button>
              )}
            </div>
            {Array.isArray(jsonData) &&
              jsonData.map((inp, i) => (
                <div key={i} className={styles.inputField}>
                  <div className={styles.titleContainer}>
                    <h3>
                      {inp.title}{" "}
                      {inp.required ? (
                        <span style={{ color: "#f5004ecf" }}>*</span>
                      ) : (
                        ""
                      )}
                    </h3>
                    {adminVendorId === productVendorId && (
                      <MdOutlineEditNote
                        onClick={(e) => editFieldOpenHandler(inp, i, e)}
                        className={styles.addFieldEditButton}
                      />
                    )}
                  </div>
                  <input
                    type={inp.type}
                    placeholder={inp.placeholder}
                    name={inp.name}
                    required={inp.required}
                    value=""
                    readOnly
                  />
                  <div>
                    {inp.info !== null && (
                      <>
                        <p>
                          {inp.info}{" "}
                          {inp.link && (
                            <a
                              href={inp.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know More
                            </a>
                          )}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              ))}
            <div className={styles.flexBox}>
              <button
                className={styles.saveButton}
                onClick={requiredFieldCloseHandler}
              >
                Save
              </button>
            </div>
          </section>
        )}
      </div>

      {/* ADD FIELD DIALOG HANDLER */}
      {showAddFieldModal && (
        <>
          {" "}
          <div className={styles.backdrop} onClick={addFieldCloseHandler}></div>
          <div onHide={addFieldCloseHandler} className={styles.modalContainer}>
            <h2 className={styles.h2}>Add New Field Details</h2>
            <Form className={styles.mainForm}>
              <Form.Group controlId="formType" className={styles.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  value={type}
                  onChange={(e) => {
                    setErrorMsg("");
                    setType(e.target.value);
                  }}
                  className={styles.formControl}
                >
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                </Form.Select>
              </Form.Group>
              <Form.Group
                controlId="formPlaceholder"
                className={styles.formGroup}
              >
                <Form.Label>PlaceHolder</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter placeholder"
                  value={placeholder}
                  onChange={(e) => {
                    setErrorMsg("");
                    setPlaceholder(e.target.value);
                  }}
                  className={styles.formControl}
                />
              </Form.Group>
              <Form.Group controlId="formTitle" className={styles.formGroup}>
                <Form.Label>Title (It will be shown to end user)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter title"
                  value={title}
                  onChange={(e) => {
                    setErrorMsg("");
                    setTitle(e.target.value);
                  }}
                  className={styles.formControl}
                />
              </Form.Group>
              <Form.Group controlId="formRequired" className={styles.formGroup}>
                <Form.Label>Required (Shows a mandatory field)</Form.Label>
                <ButtonGroup style={{ marginLeft: "5px" }}>
                  <button
                    className={
                      required ? styles.primary : styles.outlinePrimary
                    }
                    onClick={() => setRequired(true)}
                  >
                    True
                  </button>
                  <button
                    className={!required ? styles.danger : styles.outlineDanger}
                    onClick={() => setRequired(false)}
                  >
                    False
                  </button>
                </ButtonGroup>
              </Form.Group>
              <Form.Group controlId="formName" className={styles.formGroup}>
                <Form.Label>
                  Name (For backend, eg format -: first_name)
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => {
                    setErrorMsg("");
                    setName(e.target.value);
                  }}
                  className={styles.formControl}
                />
              </Form.Group>
              <Form.Group controlId="formInfo" className={styles.formGroup}>
                <Form.Label>
                  Info/Tips (Small description, will be shown to user)
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter info"
                  value={info}
                  onChange={(e) => {
                    setErrorMsg("");
                    setInfo(e.target.value);
                  }}
                  className={styles.formControl}
                />
              </Form.Group>
              <Form.Group controlId="formLink" className={styles.formGroup}>
                <Form.Label>Link (Link to any tips/page for user)</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter link"
                  value={link}
                  onChange={(e) => {
                    setErrorMsg("");
                    setLink(e.target.value);
                  }}
                  className={styles.formControl}
                />
              </Form.Group>

              {errorMsg !== "" && (
                <p className={styles.fieldsErr}>{errorMsg}</p>
              )}
              <button
                onClick={addFieldSubmitHandler}
                variant="primary"
                type="submit"
                className={styles.submitButton}
              >
                {addFieldLoader ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  "Submit"
                )}
              </button>
            </Form>
          </div>{" "}
        </>
      )}

      {/* Edit FIELD DIALOG HANDLER */}
      {showEditFieldModal && (
        <>
          {" "}
          <div
            className={styles.backdrop}
            onClick={editFieldCloseHandler}
          ></div>
          <div onHide={addFieldCloseHandler} className={styles.modalContainer}>
            <Form className={styles.mainForm}>
              <h2 className={styles.h2}>Edit Field Details</h2>
              <Form.Group controlId="formType" className={styles.formGroup}>
                <Form.Label>Type</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                />
              </Form.Group>
              <Form.Group
                controlId="formPlaceholder"
                className={styles.formGroup}
              >
                <Form.Label>PlaceHolder</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter placeholder"
                  value={placeholder}
                  onChange={(e) => setPlaceholder(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formTitle" className={styles.formGroup}>
                <Form.Label>Title</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formRequired" className={styles.formGroup}>
                <Form.Label>Required</Form.Label>
                <ButtonGroup style={{ marginLeft: "5px" }}>
                  <Button
                    variant={required ? "primary" : "white"}
                    onClick={() => setRequired(true)}
                  >
                    True
                  </Button>
                  <Button
                    variant={!required ? "primary" : "white"}
                    onClick={() => setRequired(false)}
                  >
                    False
                  </Button>
                </ButtonGroup>
              </Form.Group>
              <Form.Group controlId="formName" className={styles.formGroup}>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formInfo" className={styles.formGroup}>
                <Form.Label>Info</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter info"
                  value={info}
                  onChange={(e) => setInfo(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formLink" className={styles.formGroup}>
                <Form.Label>Link</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter link"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
              </Form.Group>

              <button
                onClick={editFieldSubmitHandler}
                variant="primary"
                type="submit"
                className={styles.submitButton}
              >
                {editFieldLoader ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  "Submit"
                )}
              </button>
            </Form>
          </div>{" "}
        </>
      )}
    </>
  );
};

export default MarketPlaceRequiredField;
